import request from "utils/request";

//法律知识分类页
function getlawify(data) {
  return request({
    url: "/api/knowledgecats",
    params: data
  });
}

//法律聚焦列表
function getnewslist(data) {
  return request({
    url: "/api/newslist",
    params: data
  });
}

//法律聚焦内容
function getnewscontent(data) {
  return request({
    url: "/api/newscontent",
    params: data
  });
}

//视频列表
function getvideolist(data) {
  return request({
    url: "/api/videolist",
    params: data
  });
}

//视频内容
function getvideocontent(data) {
  return request({
    url: "/api/videocontent",
    params: data
  });
}


//音频列表
function getaudiolist(data) {
  return request({
    url: "/api/radiolist",
    params: data
  });
}

//音频内容
function getaudiocontent(data) {
  return request({
    url: "/api/radiocontent",
    params: data
  });
}

//律师解答列表
function getarticlist(data) {
  return request({
    url: "/api/answerlist",
    params: data
  });
}

//律师解答内容
function getarticcontent(data) {
  return request({
    url: "/api/answercontent",
    params: data
  });
}


export default {
  getlawify,
  getnewslist,
  getnewscontent,
  getvideolist,
  getvideocontent,
  getaudiolist,
  getaudiocontent,
  getarticlist,
  getarticcontent

};